import styled from "styled-components";

export const TicketContainer = styled.div`
    width: 100%;

    box-sizing: border-box;

    border-radius: 8px;
`